module.exports = __webpack_public_path__ + "static/media/floorplan_camera.10b7cb6b.png";